import bannerTemp from '@/templates/bannerTemp'
import titleTemp1 from '@/templates/titleTemp1'
import titleTemp2 from '@/templates/titleTemp2'
import module1 from '@/templates/module1'

const templates = {
    install: function (Vue) {
        Vue.component("bannerTemp", bannerTemp)
        Vue.component("titleTemp1", titleTemp1)
        Vue.component("titleTemp2", titleTemp2)
        Vue.component("module1", module1)
    }
}
export default templates


// WEBPACK FOOTER //
// ./src/templates/templates.js